import {useEffect,useId,useRef,useState} from 'react';
import type {SleepCapacity} from './sleep-capacity';
import './SleepCapacityNotice.css';

export function SleepCapacityNotice({status}:{status?:SleepCapacity}){
 if(!status?.shortfall)return null;
 return <aside className="bliss-capacity-notice" aria-label="Sleeping capacity" role="status">
  <strong>Sleep capacity goal NOT achieved</strong>
  <p>Sleeps {status.capacity} of your goal of {status.goalLabel}. Add a bunk for {status.goal===6?'at least ':''}{status.shortfall} more sleeping {status.shortfall===1?'space':'spaces'}, or review your bunk sizes.</p>
  <small>Full and queen mattresses count as two sharing. Room fit still needs confirmation.</small>
 </aside>;
}
/** Render only after checkout is requested. Remount for every changed order. */
export function SleepCapacityConfirmation({status,busy=false,onAdd,onContinue}:{status:SleepCapacity;busy?:boolean;onAdd:()=>void;onContinue:()=>void}){
 const id=useId(),heading=useRef<HTMLHeadingElement>(null),[acknowledged,setAcknowledged]=useState(false);
 useEffect(()=>{heading.current?.focus({preventScroll:true});heading.current?.scrollIntoView({block:'center',behavior:'smooth'})},[]);
 return <section className="bliss-capacity-confirmation" aria-labelledby={id}>
  <h2 id={id} ref={heading} tabIndex={-1}>Sleep capacity goal NOT achieved</h2>
  <p>This order sleeps {status.capacity}. Your goal is {status.goalLabel}.</p>
  <button type="button" className="bliss-capacity-add" disabled={busy} onClick={onAdd}>Add a bunk (recommended) →</button>
  <label className="bliss-capacity-ack"><input type="checkbox" checked={acknowledged} disabled={busy} onChange={e=>setAcknowledged(e.target.checked)}/><span>I’m happy to continue with {status.capacity} sleeping spaces.</span></label>
  <button type="button" className="bliss-capacity-continue" disabled={busy||!acknowledged} onClick={onContinue}>{busy?'Opening secure payment…':'Continue with this order →'}</button>
 </section>;
}
